<router-outlet></router-outlet>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type= "ball-beat" [fullScreen]="true"></ngx-spinner>